// extracted by mini-css-extract-plugin
module.exports = {"header-logo":"PartnerComponent_header-logo__t6hxP"};